module.exports = __webpack_public_path__ + "pc/img/about_solution01.1f4f1c31.jpg";